export const statusColors = {
  ACTIVE: "bg-[#ECFDF3] text-[#039855] border-[#039855]",
  OPEN: "bg-[#ECFDF3] text-[#039855] border-[#039855]",
  HIRED: "bg-[#E4F2FE] text-[#3C93F7] border-[#3C93F7]",
  CANCELED: "bg-[#FEF2F2] text-[#F03D3D] border-[#F03D3D] ",
  COMPLETED: "bg-[#ECF4FD] text-[#056FC0] border-[#056FC0] ",
  APPROVED: "bg-[#ECF4FD] text-[#056FC0] border-[#056FC0] ",
  Draft: " text-[#3A4151] border-[#3A4151] ",
  New: "bg-[#E4F2FE] text-[#3C93F7] border-[#3C93F7]",
  Pending: "bg-[#FDECEC] text-[#AB3C3C] border-[#AB3C3C]",
  ASSIGNING_VENDOR: "bg-[#52C2711A] text-[#52C271] border-[#52C271]",
  PENDING_APPROVAL: "bg-[#FC953A1A] text-[#FFB573] border-[#FFB573]",
  IN_PROGRESS: "bg-[#D4B1001A] text-[#D4B100] border-[#D4B100]",
  Draft: " text-[#3A4151] border-[#3A4151] ",
  New: "bg-[#E4F2FE] text-[#3C93F7] border-[#3C93F7]",
  // IN_PROGRESS: "bg-[#FDECEC] text-[#AB3C3C] border-[#AB3C3C]",
  "Assigning Vendor": "bg-[#52C2711A] text-[#52C271] border-[#52C271]",
  // "In Progress": "bg-[#D4B1001A] text-[#D4B100] border-[#D4B100]",
};
export const statusDots = {
  ACTIVE: "bg-[#039855] ",
  OPEN: "bg-[#039855] ",
  HIRED: "bg-[#3C93F7] ",
  CANCELED: "bg-[#F03D3D] ",
  APPROVED: "bg-[#056FC0] ",
  COMPLETED: "bg-[#056FC0] ",
  Draft: "bg-[#3A4151]",
  "Assigning Vendor": "bg-[#52C271] ",
  "In Progress": "bg-[#D4B100] ",
};
export const status = {
  ACTIVE: "Active ",
  OPEN: "bg-[#039855] ",
  HIRED: "bg-[#3C93F7] ",
  CANCELED: "Cancelled",
  ASSIGNING_VENDOR: "Assigning Vendor",
  PENDING_APPROVAL: "Pending Approval",
  COMPLETED: "Completed ",
  IN_PROGRESS: "In Progress",
};
